import { IUpdateAiBotSettingsDTO } from '@/models/aiBotSettings.model';
import { AiBotConfigFormFields, TAiBotConfigFormValues } from '../helpers/types';

class UpdateAiBotSettingsDTO implements IUpdateAiBotSettingsDTO {
  channelSlug: string;

  senderName?: string;

  mainColor?: string;

  welcomeMessage?: string;

  disclaimerMessage?: string;

  constructor(values: Partial<TAiBotConfigFormValues> & { channelSlug: string }) {
    this.channelSlug = values.channelSlug;

    if (values[AiBotConfigFormFields.SENDER_NAME]) {
      this.senderName = values[AiBotConfigFormFields.SENDER_NAME];
    }

    const color = values[AiBotConfigFormFields.MAIN_COLOR];
    const hex = typeof color === 'string' ? color : color?.toHexString?.();
    if (hex) {
      this.mainColor = hex;
    }

    if (values[AiBotConfigFormFields.WELCOME_MESSAGE]) {
      this.welcomeMessage = values[AiBotConfigFormFields.WELCOME_MESSAGE];
    }

    if (values[AiBotConfigFormFields.DISCLAIMER_MESSAGE]) {
      this.disclaimerMessage = values[AiBotConfigFormFields.DISCLAIMER_MESSAGE];
    }
  }
}

export default UpdateAiBotSettingsDTO;
